var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab-item',{attrs:{"eager":"","transition":false}},[_c('div',{staticClass:"tab-layout__row"},[_c('div',{staticClass:"tab-layout__side"},[_vm._t("side")],2),_c('div',{staticClass:"tab-layout__main"},[_vm._t("main")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }